export default {
  memberPaymentPlans: [],
  currentPaymentPlan: null,
  nextInstallment: null,
};
